export default __webpack_public_path__ + "fonts/block-phone.svg";